import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledCardTime = styled.div<{ selected: boolean }>`
  padding: 4px 4px 4px 10px;
  border-radius: ${theme.variables.border_radius_6};
  cursor: pointer;
  background-color: ${({ selected }) =>
    selected ? `${theme.colors.purple_2}` : `${theme.colors.white}`};
  color: ${({ selected }) => (selected ? "white" : "black")};
  font-weight: 500;
  gap: 7px;
  display: flex;
  flex-direction: row;
  align-items: center;
  width: ${({ selected }) => (selected ? "90px" : "auto")};
  justify-content: space-between;

  &:hover {
    background-color: ${theme.colors.purple_2};
  }
`;

export const StyledTime = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
`;
